import { GET_VENDORS_LIST_DATA, GET_VENDORS_LIST_DATA_SUCCESS, GET_VENDORS_LIST_DATA_ERROR, GET_VENDORS_LIST_DATA_EMPTY } from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetVendorsListData = (state = initialState, action) => {
  switch (action.type) {
    case GET_VENDORS_LIST_DATA:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_VENDORS_LIST_DATA_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_VENDORS_LIST_DATA_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_VENDORS_LIST_DATA_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetVendorsListData;
